import { GeoEventFormStatus } from 'shared/types';

export const statusToTransKey: Record<GeoEventFormStatus, string> = {
  inactive: 'common.inactive',
  active: 'common.active',
};
